import React from 'react';
import GeoLayer from '../layers';
import { MapContainer, useMap } from 'react-leaflet';

const defaultProps = {
  center: [38.9637, 35.2433],
  zoom: 6.3,
  zoomDelta: 0.25,
  zoomSnap: 0,
  zoomControl: false,
  scrollWheelZoom: false,
  dragging: false,
  doubleClickZoom: false,
};

const MapView = () => {
  const MyComponent = () => {
    const map = useMap();

    map.fitBounds(map.getBounds());
    // map.fitBounds(defaultProps.center);
    return null;
  };

  return (
    <MapContainer {...defaultProps}>
      {/*
        <TileLayer url="http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png" />
      */}
      <GeoLayer />
      <MyComponent />
    </MapContainer>
  );
};

export default MapView;
